import { render, staticRenderFns } from "./XLogViewer.vue?vue&type=template&id=1a2644d8&scoped=true"
import script from "./XLogViewer.vue?vue&type=script&lang=js"
export * from "./XLogViewer.vue?vue&type=script&lang=js"
import style0 from "./XLogViewer.vue?vue&type=style&index=0&id=1a2644d8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a2644d8",
  null
  
)

export default component.exports